/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PromotionCampaignPrizeAmountMode } from './PromotionCampaignPrizeAmountMode';
import {
    PromotionCampaignPrizeAmountModeFromJSON,
    PromotionCampaignPrizeAmountModeFromJSONTyped,
    PromotionCampaignPrizeAmountModeToJSON,
} from './PromotionCampaignPrizeAmountMode';

/**
 * 
 * @export
 * @interface PromotionCampaignPrizeAmount
 */
export interface PromotionCampaignPrizeAmount {
    /**
     * 
     * @type {number}
     * @memberof PromotionCampaignPrizeAmount
     */
    value: number;
    /**
     * 
     * @type {PromotionCampaignPrizeAmountMode}
     * @memberof PromotionCampaignPrizeAmount
     */
    mode: PromotionCampaignPrizeAmountMode;
}



/**
 * Check if a given object implements the PromotionCampaignPrizeAmount interface.
 */
export function instanceOfPromotionCampaignPrizeAmount(value: object): value is PromotionCampaignPrizeAmount {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('mode' in value) || value['mode'] === undefined) return false;
    return true;
}

export function PromotionCampaignPrizeAmountFromJSON(json: any): PromotionCampaignPrizeAmount {
    return PromotionCampaignPrizeAmountFromJSONTyped(json, false);
}

export function PromotionCampaignPrizeAmountFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionCampaignPrizeAmount {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'mode': PromotionCampaignPrizeAmountModeFromJSON(json['mode']),
    };
}

export function PromotionCampaignPrizeAmountToJSON(value?: PromotionCampaignPrizeAmount | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'mode': PromotionCampaignPrizeAmountModeToJSON(value['mode']),
    };
}

